import ImageSlider from './ImageSlider'
import React, { useCallback, useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { axios, makeQueryStr } from '../../utils'
// import NumberInput from '../../shared/components/NumberInput'
// import { Row, Col, Button, Modal, ModalHeader, Container } from 'reactstrap'
// import { ContentfulContext } from '../../shared/ContentfulContext';
// import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Swiper } from 'swiper/react'
import { Pagination, Navigation } from 'swiper'
//import './nice-select.css'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as R from 'ramda'
import { pathOr } from 'ramda'
import TransactionHOC from '../Reusable/TransactionHOC'
import ProductHOC from '../Reusable/ProductHOC'
import { changeQuantity, setUom, setAlternativeItems, setCorrelatedItems } from '../../actions'
import { getUrlComponent } from '../../utils'
import ProductDetailsQuantityTypeDropdown from '../ProductDetails/ProductDetailsQuantityTypeDropdown'
import ProductDetailsMatrixDropdown from '../ProductDetails/ProductDetailsMatrixDropdown'
import ProductDetailsQuantityInput from '../ProductDetails/ProductDetailsQuantityInput'
import { ProductDetailsContext } from '../ProductDetails/ProductDetailsContext'
import ItemCarouselCard from './ItemCarouselCard'
import ProductDetailsAddToCart from '../ProductDetails/ProductDetailsAddToCart'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import AddToItemListDropdown from '../ItemList/AddToItemListDropdown'
import CheckmarkSVG from '../../shared/icons/CheckmarkSVG'
import ErrorSVG from '../../shared/icons/ErrorSVG'
import CloseSVG from '../../shared/icons/CloseSVG'
// import ProductSchemaMarkup from './ProductSchemaMarkup';
import DealmedDialog from '../../shared/components/DealmedDialog'
import TopProducts from '../Category/TopProducts'
import ProductDetailsShareDialog from '../ProductDetails/ProductDetailsShareDialog'
import ProductDetailsQuestionsDialog from '../ProductDetails/ProductDetailsQuestionsDialog'
import '../ProductDetails/ProductDetails.scss'
import '../Content/content.scss'
import 'swiper/swiper-bundle.min.css'
import './SingleProduct.scss'
import ProductDetailsDescriptionBox from './ProductDetailsDescriptionBox'
import ProductDetailsAfterAddPage from './ProductDetailsAfterAddPage'
import { mixpanelLogEvent } from '../../utils/mixpanelLogEvent'
import { FormControlLabel, Switch, Tooltip, Typography } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#b92a47', // Your custom color
    },
    secondary: {
      main: '#b92a47', // Your custom color
    },
  },
})

const CATEGORY_ROUTE = 'api/shopping/category/category'
const { REACT_APP_STORAGE_URL, REACT_APP_CONT_PRODUCT_IMG, PUBLIC_URL } = process.env
const IMAGE_URL = REACT_APP_STORAGE_URL + REACT_APP_CONT_PRODUCT_IMG
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const ITEM_ROUTE = 'api/shopping/item'
const fetchTopProducts = async () => {
  return axios
    .get(`${ITEM_ROUTE}/topProducts`)
    .then(response => {
      // console.log('Response From Top Products', response)
      return pathOr([], ['data', 'topProducts'], response)
    })
    .catch(e => {
      console.log('Error fetching Top Products', e)
      return []
    })
}

const ProductDetailsPage = props => {
  const [state, setState] = useState({
    bigImageSrc: null,
    conversionRate: 1,
    active: null,
  })
  const [productQuantity, setProductQuantity] = useState(1)
  const [featuredProducts, setFeaturedProducts] = useState([])
  const [algoliaRecommendsItems, setAlgoliaRecommendsItems] = useState([])
  const [modal, setModal] = useState(false)
  const [topProducts, setTopProducts] = useState([])
  const [selectedQuantity, setSelectedQuantity] = useState(1)
  const [showAfterAddPage, setShowAfterAddPage] = useState(true)
  const [isNotificationItem, setIsNotificationItem] = useState(false)
  const isAuthenticated = Boolean(R.pathOr(false, ['user', 'id'], props.auth))

  const toggle = () => setModal(!modal)
  const {
    location,
    match,
    setUom,
    history,
    setProduct,
    setAlternativeItems,
    setCorrelatedItems,
    resetProduct,
    changeQuantity,
  } = props

  const {
    attributes,
    allocationPeriod,
    category,
    displayName,
    siteDisplayName,
    id: itemId,
    itemImage,
    itemFile,
    itemName,
    manufacturer,
    metaTag,
    mpn,
    price,
    rxLevel,
    titleTag,
    unit,
  } = props.product.data

  const isPriceVisible = props.auth.user
    ? R.pathOr(false, ['auth', 'user', 'permissions', 'isPriceVisible'], props)
    : null

  const updateProductQuantity = quantity => {
    setProductQuantity(quantity)
  }

  const getFeaturedProducts = async categoryId => {
    const queryParams = {
      category_id: categoryId,
      includeSubcategories: true,
      includeFeaturedProducts: true,
      includeRelatedCategories: true,
    }
    if (categoryId) {
      try {
        const queryStr = makeQueryStr(queryParams)
        const response = await axios.get(`${CATEGORY_ROUTE}?${queryStr}`)

        const { data } = response
        const featuredProductsToSet = pathOr([], ['featuredProducts'], data)

        return setFeaturedProducts(featuredProductsToSet)
      } catch (e) {
        console.log('Error Getting Featured Items: ', e)
      }
    }
  }

  const getAlgoliaRecommendsItems = async () => {
    const response = await axios.get(
      `${ITEM_ROUTE}/algoliaRecommendsItems?id=${String(productInternalId)}`,
    )
    setAlgoliaRecommendsItems(response.data)
  }

  const getListPrice = item => {
    for (let priceId in item.prices) {
      if (item.prices[priceId].level === 'List Price') {
        return item.prices[priceId].price
      }
    }
    return null
  }

  const toggleIsNotificationItem = async () => {
    try {
      setIsNotificationItem(prevIsNotificationItem => !prevIsNotificationItem)
      const response = await axios.post(`${ITEM_ROUTE}/createDeleteItemNotification`, {
        userId: props.auth?.user?.id,
        itemId,
      })
      logClickEvent({ eventType: 'PDP_Stock_Toggle_Click' })
    } catch (error) {
      console.error('Error updating item notification', error)
    }
  }

  async function getIsItemNotification() {
    try {
      const response = await axios.post(`${ITEM_ROUTE}/isItemNotification`, {
        userId: props.auth?.user?.id,
        itemId,
      })
      setIsNotificationItem(response?.data?.exists)
    } catch (error) {
      console.error('Error updating item notification', error)
    }
  }

  useEffect(() => {
    const func = async () => {
      window.scrollTo(0, 0)
      changeQuantity(1)
      setUom({})
      const id = match.params.id

      const topProductsToSet = await fetchTopProducts()
      // const topProductsToSet = await topProductsProm
      setTopProducts(topProductsToSet)

      const { hash } = location
      const activeNum = hash == '#pd' ? 0 : hash == '#rp' ? 1 : hash == '#ap' ? 2 : null
      setState({ ...state, active: activeNum })

      if (!id) return history.replace('/products')

      await setProduct(id, true)
      setCorrelatedItems(id)
      setAlternativeItems(id)
    }

    func()
    getFeaturedProducts(category?._parentId)

    return () => {
      resetProduct()
    }
  }, [])

  const resetState = () => {
    setState({
      ...state,
      bigImageSrc: null,
      conversionRate: 1,
      active: null,
    })
  }

  const logClickEvent = ({ eventType }) => {
    mixpanelLogEvent({
      eventType,
      userDetails: props?.auth?.user,
      itemDetails: props?.product?.data,
      metaData: {
        selectedQuantity,
      },
    })
  }

  useEffect(() => {
    const func = async () => {
      const currentId = match.params.id
      resetState()
      changeQuantity(1)
      setUom({})
      await setProduct(currentId)
      await setAlternativeItems(currentId)
      await setCorrelatedItems(currentId)

      // if (!props.product.data.children.length > 0) {
      //   window.scrollTo(0, 0);
      // }
    }
    window.scrollTo(0, 0)

    func()
    setShowAfterAddPage(false)
  }, [match.params.id])

  useEffect(() => {
    getFeaturedProducts(category?._parentId)
  }, [category])

  useEffect(() => {
    if (itemId && quantityAvailable < 1 && isAuthenticated) {
      getIsItemNotification()
    }

    if (productInternalId) {
      getAlgoliaRecommendsItems()
    }
  }, [itemId])

  const selectItem = (children, id) =>
    R.find(f => id == f.urlComponent || id == f.id)(children) || children[0]

  const onUomChange = (uom, units) => {
    if (!units) {
      return
    }

    let foundUnit = units.find(f => f.value === uom.value)
    let newState = { ...state }
    newState.conversionRate = foundUnit.conversionRate || 1
    setState(newState)
    setUom(uom)
  }

  let id = match.params.id

  const product =
    props.product.data.children && props.product.data.children.length > 0
      ? R.mergeDeepRight(props.product.data, selectItem(props.product.data.children, id))
      : props.product.data

  const listPrice = formatter.format(getListPrice(product))

  const productName = product.siteDisplayName || product.displayName
  const productManufacturer = product.manufacturer
  const productId = product.itemName
  const productMPN = product.mpn
  const productInternalId = product.id
  const avgRestockDays = product.avgRestockDays
  const requiresMedicalLicense = product.rxLevel
  const baseUnitTranslation = product.baseUnitTranslation

  const quantityAvailable = R.pathOr(0, ['quantityAvailable'], product)
  let description = R.pathOr('', ['description'], product)
  if (description) {
    description = description.replace(/<br>/g, '')
  }

  // Safely access product.unit.details or default to an empty array
  const unitDetails = (product.unit && product.unit.details) || []
  let units = unitDetails.map((unit, index) => {
    let label

    // Condition 1: If the first unit is currently selected
    if (index === 0) {
      label = product.baseUnitTranslation || unit.unitName
    }
    // Condition 2: If the label is "Each"
    else if (unit.unitName === 'Each') {
      label = 'Unit'
    }
    // Fallback: Use the original label
    else {
      label = unit.unitName
    }
    return {
      value: unit.id,
      label: label,
      conversionRate: unit.conversionRate,
      baseUnit: unit.baseUnit,
    }
  })

  const search = window.location.search
  const params = new URLSearchParams(search)
  const uom = params.get('uom')
  const defaultUnit =
    (uom ? units.find(unit => unit.value == uom) : R.find(unit => unit.baseUnit, units)) || {}

  const setProductImage = useCallback(
    imageSrc => {
      setState({ ...state, bigImageSrc: imageSrc })
    },
    [state.bigImageSrc],
  )

  if (product.id) {
    const urlComp = getUrlComponent(product)

    const isProductAvailable = () => {
      if (quantityAvailable > 0) {
        return true
      }
      return false
    }

    const thumbnailImage = product.children
      ? product.children[R.findIndex(R.propEq(product.id, 'id'))(product.children)]?.thumbnailImage
      : null
    const parentThumbnailImage = R.pathOr('', ['product', 'data', 'thumbnailImage'], props)

    const metaDescriptionTag = R.pathOr('', ['metaTag'], product)
    const titleTag = R.pathOr('', ['titleTag'], product)
    const productAttributes = product?.attributes || {}

    const productImageSrc = state.bigImageSrc
      ? state.bigImageSrc
      : thumbnailImage
      ? IMAGE_URL + thumbnailImage
      : R.pathOr([], ['itemImage'], product).length > 0
      ? product.itemImage[0].largeUrl
      : parentThumbnailImage
      ? IMAGE_URL + parentThumbnailImage
      : `${PUBLIC_URL}/images/imageComingSoon.png`

    const selectedUnit = Object.keys(props.uom).length === 0 ? defaultUnit : props.uom
    let productPrice = formatter.format(product.price * props.quantitySelected)
    if (selectedUnit.conversionRate) {
      productPrice = formatter.format(
        product.price * selectedUnit.conversionRate * props.quantitySelected,
      )
    }

    let singleProductPrice = formatter.format(product.price)
    if (selectedUnit.conversionRate) {
      singleProductPrice = formatter.format(product.price * selectedUnit.conversionRate)
    }

    const downloads = R.pathOr([], ['itemFile'], product)
    const relatedProducts = R.pathOr([], ['correlatedItems'], props)
    const alternativeProducts = R.pathOr([], ['alternativeItems'], props)
    const matrixItems = R.pathOr(false, ['children'], product)
    const matrixItemDetailString = product.matrixDetails ? Object.values(product.matrixDetails) : ''
    const matrixDetailsLabel =
      matrixItems.length > 0 && Object.keys(matrixItems[0]?.matrixDetails)[0]
    const requiresMedicalLicense = product.rxLevel
    const enhancedRelatedProducts = Object.values(algoliaRecommendsItems) // Get all values (arrays) from algoliaRecommendsItems
      .flatMap(items => items) // Flatten all arrays into a single array
      .concat(relatedProducts) // Concatenate with props.alternativeItems

    let displayTabNavigation = false

    if (
      (!R.isEmpty(downloads) && relatedProducts.length > 0) ||
      (!R.isEmpty(downloads) && alternativeProducts.length > 0) ||
      (relatedProducts.length > 0 && alternativeProducts.length > 0)
    ) {
      displayTabNavigation = true
    }

    return (
      <ProductDetailsContext.Provider value={props}>
        <Helmet>
          <meta
            name="keywords"
            content={`${product.manufacturer},${product.mpn},${product.searchKeywords},best`}
          />
          {/* <meta name="description" content={metaDescriptionTag} */}
          <meta
            name="description"
            content={`Get the best prices on ${matrixItemDetailString} ${
              product.siteDisplayName || product.displayName
            }'s from Dealmed. We offer a wide selection of top-notch products!`}
          />
          <meta name="robots" content="index,follow" />
          <title>
            {titleTag ||
              (product.siteDisplayName || product.displayName) +
                (product.matrixDetails ? ' - ' + Object.values(product.matrixDetails) : '')}{' '}
            | Dealmed Medical Supplies
          </title>
          <link rel="canonical" href={`https://dealmed.com/product/${urlComp}`} />
        </Helmet>
        {showAfterAddPage ? (
          <div
            className="product-item prdi"
            style={{ backgroundColor: '#f9eeeb', padding: '11px 22px 22px' }}
          >
            <ProductDetailsAfterAddPage
              item={props.product.data}
              isAuthenticated={isAuthenticated}
              setShowAfterAddPage={setShowAfterAddPage}
              logClickEvent={logClickEvent}
              enhancedRelatedProducts={enhancedRelatedProducts}
            />
          </div>
        ) : (
          <div className="page-holder singleProduct">
            {/* Top Banner */}
            <div className="product-info-banner pib">
              <div className="container conditionally-render">
                <div className="pib__block">
                  <p className="pib__text">Low Price Guarantee</p>
                  <p className="pib__text">24-Hour Delivery</p>
                  <p className="pib__text">Live Customer Service 24/7</p>
                </div>
              </div>
            </div>
            {/* Breadcrumb */}
            <div className="breadcrumb-block ">
              <div className="container">
                <div className="bbnew__steps bb__marginLeft">
                  <a className="bbnew__steps--noactive" href="/">
                    Home &#183;{' '}
                  </a>
                  <a className="bbnew__steps--noactive" href="/shop">
                    Products &#183;{' '}
                  </a>
                  {/* <a
                  className="bb__steps--noactive"
                  href={`/category/${props?.category?.urlComponent}`}
                >
                  {props?.category?.name}
                </a> */}
                  <a
                    className="bbnew__steps--noactive"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      if (props?.category?.urlComponent) {
                        history.push(`/category/${props?.category?.urlComponent}`)
                      }
                    }}
                  >
                    {props?.category?.name}
                  </a>
                  {/* <a className="bb__steps--active" href="">
                Product
              </a> */}
                </div>
              </div>
            </div>

            <div className="product-item prdi">
              <div className="container">
                <div className="prdi__wrapper">
                  <div className="prdi__block-left">
                    <ImageSlider itemImage={itemImage} />
                  </div>
                  <div className="prdi__block-right">
                    <div className="prdi__info">
                      <h4 className="prdi__manufacturer">{productManufacturer}</h4>
                      <h2 className="prdi__title">{productName}</h2>

                      {product.price !== 'N/A' && (
                        <div
                          className="prdi__inputs-block instock"
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                          <div style={{ display: 'flex' }}>
                            {isPriceVisible && product.price !== 'N/A' && (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  gap: '8px',
                                }}
                              >
                                <h4
                                  className="productDetails__products-box-stock-price"
                                  style={{ fontWeight: '600', fontSize: '28px' }}
                                >
                                  {singleProductPrice}
                                </h4>
                                {Number(listPrice.replace(/[^0-9.-]+/g, '')) >
                                  Number(singleProductPrice.replace(/[^0-9.-]+/g, '')) && (
                                  <h4
                                    className="productDetails__products-box-stock-price"
                                    style={{
                                      fontSize: '16px',
                                      color: '#3F4647',
                                      textDecoration: 'line-through',
                                    }}
                                  >
                                    {listPrice}
                                  </h4>
                                )}
                              </div>
                            )}
                            <div
                              className="productDetails__products-box-stock-block"
                              style={{ marginLeft: '12px' }}
                            >
                              {quantityAvailable > 0 || (avgRestockDays && avgRestockDays <= 3) ? (
                                <div
                                  style={{
                                    fontSize: '12px',
                                    color: '#217625',
                                    backgroundColor: '#E7FFE8',
                                    padding: '8px 16px',
                                    fontWeight: '600',
                                  }}
                                >
                                  <span>In Stock</span>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    fontSize: '12px',
                                    color: '#9B9191',
                                    backgroundColor: '#F7F7F7',
                                    padding: '8px 16px',
                                    fontWeight: '600',
                                  }}
                                >
                                  <span>Out of Stock</span>
                                </div>
                              )}
                            </div>
                            {quantityAvailable < 1 &&
                              isAuthenticated &&
                              (!avgRestockDays || avgRestockDays > 3) && (
                                <div
                                  className="productDetails__products-box-stock-block"
                                  style={{ marginLeft: '12px' }}
                                >
                                  <ThemeProvider theme={theme}>
                                    <Tooltip title="Toggle to be notified and have an email sent when this item comes back in stock!">
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={isNotificationItem}
                                            onChange={toggleIsNotificationItem}
                                            color="primary"
                                            // label="Notify Me When Back In Stock"
                                          />
                                        }
                                        label={
                                          <Typography style={{ fontSize: '12px', fontWeight: 600 }}>
                                            Notify Me When Back In Stock
                                          </Typography>
                                        }
                                      />
                                    </Tooltip>
                                  </ThemeProvider>
                                </div>
                              )}
                          </div>
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <ProductDetailsQuestionsDialog logClickEvent={logClickEvent} />
                            <ProductDetailsShareDialog logClickEvent={logClickEvent} />
                          </div>
                        </div>
                      )}

                      <div className="prdi__inputs">
                        <div
                          style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}
                          className="prdi__inputs-group"
                        >
                          {units.length > 0 && (
                            <div className="prdi__inputs-block component">
                              <span className="prdi__inputs-label">Units</span>
                              <ProductDetailsQuantityTypeDropdown
                                id="product-quantity-type-dropdown"
                                units={units}
                                updateUnits={selectedUnit => onUomChange(selectedUnit, units)}
                                value={selectedUnit}
                              />
                            </div>
                          )}
                          {matrixItems.length > 0 ? (
                            <div className="prdi__inputs-block component">
                              <span className="prdi__inputs-label">{matrixDetailsLabel}</span>
                              <ProductDetailsMatrixDropdown
                                id="matrix-products-dropdown"
                                matrixItems={matrixItems}
                                product={product}
                                uom={selectedUnit}
                              />
                            </div>
                          ) : null}
                          <div className="prdi__inputs-block component">
                            <span className="prdi__inputs-label">QTY</span>
                            <ProductDetailsQuantityInput
                              id="product-quantity-input"
                              name="product-quantity-input"
                              setSelectedQuantity={setSelectedQuantity}
                            />
                          </div>
                        </div>

                        <div className="prdi__inputs-btns">
                          {/* {isPriceVisible && product.price !== 'N/A' && (
                          <h4 className="prdi__addtocart-price">{productPrice}</h4>
                        )} */}
                          {product.price === 'N/A' ? (
                            <p className="product-details__info-invalid">
                              This product is currently unavailable. Please check back later!
                            </p>
                          ) : (
                            <>
                              <div className="product-details__info-add">
                                <ProductDetailsAddToCart
                                  product={product}
                                  allocationMax={props.allocationMax}
                                  units={!R.isEmpty(props.uom) ? props.uom : defaultUnit}
                                  setShowAfterAddPage={setShowAfterAddPage}
                                  logClickEvent={logClickEvent}
                                />
                              </div>
                            </>
                          )}
                          <div
                            className="prdi__addtolist"
                            onClick={() => {
                              logClickEvent({ eventType: 'PDP_Add_Item_To_List' })
                              toggle()
                            }}
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '12px 0px 12px',
                            }}
                          >
                            {/* <div
                            className="prdi__addtolist-icon"
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <img src={`${PUBLIC_URL}/images/addtolist-icon.png`} alt="" loading="lazy"/>
                          </div> */}
                            <div className="prdi__addtolist-select">
                              <span className="current">ADD TO LIST</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className="prdi__addtocart" style={{borderBottom:'2px solid lightgrey', borderTop:'2px solid lightgrey', padding:'12px 0'}}>
                      {isPriceVisible && product.price !== 'N/A' && (
                        <h4 className="prdi__addtocart-price">{productPrice}</h4>
                      )}
                      {product.price === 'N/A' ? (
                        <p className="product-details__info-invalid">
                          This product is currently unavailable. Please check back later!
                        </p>
                      ) : (
                        <>
                          <div className="product-details__info-add">
                            <ProductDetailsAddToCart
                              product={product}
                              allocationMax={props.allocationMax}
                              units={!R.isEmpty(props.uom) ? props.uom : defaultUnit}
                              setShowAfterAddPage={setShowAfterAddPage}
                              logClickEvent={logClickEvent}
                            />
                          </div>
                        </>
                      )}
                    <div className="prdi__widget-buttons">
                      <div
                          className="prdi__addtolist"
                          onClick={() => {
                            logClickEvent({eventType:'PDP_Add_Item_To_List'})
                            toggle()
                            }}
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '12px 0px 12px',
                          }}
                        >
                          <div
                            className="prdi__addtolist-icon"
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <img src={`${PUBLIC_URL}/images/addtolist-icon.png`} alt="" loading="lazy"/>
                          </div>
                          <div
                            className="prdi__addtolist-select">
                            <span className="current">ADD TO LIST</span>
                          </div>
                        </div>
                        <ProductDetailsQuestionsDialog logClickEvent={logClickEvent}/>
                        <ProductDetailsShareDialog logClickEvent={logClickEvent} />
                      </div>
                    </div> */}

                      <ProductDetailsDescriptionBox
                        description={description}
                        productId={productId}
                        productMPN={productMPN}
                        allocationMax={props.allocationMax}
                        allocationPeriod={allocationPeriod}
                      />

                      {Object.entries(productAttributes)?.length > 0 && (
                        <div className="prdtItem">
                          <div className="container">
                            <div className="productDetails__featured-title">
                              <h2 className="bb__name-heading">Product Details</h2>
                              {/* <p className="prcd__subheading">
                            {siteDisplayName || displayName}
                            <br />
                          </p> */}
                            </div>
                            <div className="prcd__block" style={{ flexDirection: 'column' }}>
                              <p className="prcd__block-title">Specifications:</p>
                              <div className="prcd__block-table">
                                {Object.entries(productAttributes).map((facet, index) => (
                                  <div className="prcd__block-table-item" key={index}>
                                    <p className="prcd__block-table-item-heading">{facet[0]}</p>
                                    <p className="prcd__block-table-item-subheading">{facet[1]}</p>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {product?.keyFeatures?.length > 0 && (
                              <div className="prcd__block-right">
                                <p className="prcd__block-title">Key features:</p>

                                <div className="prcd__block-kf">
                                  {product.keyFeatures.map((keyFeature, index) => (
                                    <div className="prcd__block-kf-item" key={index}>
                                      <span className="prcd__block-kf-item-icon">
                                        <img
                                          src={`${PUBLIC_URL}/images/check-circle.png`}
                                          alt=""
                                          loading="lazy"
                                        />
                                      </span>
                                      <span className="prcd__block-kf-item-title">
                                        {keyFeature}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {product.itemFile.length > 0 && (
                        <div id="downloads" className="prct__body prdtItem">
                          <div className="container">
                            <h2 className="bb__name-heading">Downloads</h2>
                            <div className="rsc__boxes" style={{ marginTop: '32px' }}>
                              {product.itemFile.map((file, index) => (
                                <div className="prdtItem__download" key={index}>
                                  <FontAwesomeIcon
                                    icon={faFilePdf}
                                    style={{ color: '#ED2525', fontSize: '100px' }}
                                  />
                                  <a className="rsc__pdf" href={file.url}>
                                    {file.name || 'Item File'}
                                  </a>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* REVISIT BELOW */}
                      {/* <div className="prdi__disclaimer">
                    <div className="prdi__disclaimer-block">
                      <span className="prdi__disclaimer-block-icon">
                        <img src={`${PUBLIC_URL}/images/warning.png`} alt="" />
                      </span>
                      <span className="prdi__disclaimer-block-text">
                        This item requires a medical license. Call Dealmed to provide your license.
                      </span>
                    </div>
                    <div className="prdi__disclaimer-block">
                      <span className="prdi__disclaimer-block-icon">
                        <img src={`${PUBLIC_URL}/images/warning.png`} alt="" />
                      </span>
                      <span className="prdi__disclaimer-block-text">
                        This item is a narcotic, and a $10.50 handling fee will be applied to your
                        order. Learn more
                      </span>
                    </div>
                    <div className="prdi__disclaimer-block">
                      <span className="prdi__disclaimer-block-icon">
                        <img src={`${PUBLIC_URL}/images/warning.png`} alt="" />
                      </span>
                      <span className="prdi__disclaimer-block-text">
                        This item is non-returnable.
                      </span>
                    </div>
                    <div className="prdi__disclaimer-block">
                      <span className="prdi__disclaimer-block-icon">
                        <img src={`${PUBLIC_URL}/images/warning.png`} alt="" />
                      </span>
                      <span className="prdi__disclaimer-block-text">
                        Orders placed for this item cannot be canceled.
                      </span>
                    </div>
                  </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="alternative-products" className="prct__content">
              <div className="prct__body active">
                {props.alternativeItems.length > 0 && (
                  <div className="productDetails__featured">
                    <div className="container">
                      <div className="productDetails__featured-title">
                        <h2 className="bb__name-heading">Alternative Products</h2>
                      </div>

                      {/* <div className="productDetails__featured-products"> */}
                      {/* {props.alternativeItems.map((item, index) => (
                        <ItemCarouselCard
                          key={index}
                          item={item}
                          isAuthenticated={isAuthenticated}
                          isPriceVisible={isPriceVisible}
                          validateRxAndAddToCart={props.validateRxAndAddToCart}
                          showStockStatus={true}
                        />
                      ))} */}

                      <div className="" style={{ marginBottom: '20px' }}>
                        <Swiper
                          className="fp__swiper swiper"
                          // slidesPerView={6}
                          modules={[Navigation, Pagination]}
                          pagination={{ clickable: true }}
                          autoplay={false}
                          spaceBetween={22}
                          navigation={{
                            nextEl: '.fp__navigation--next',
                            prevEl: '.fp__navigation--prev',
                          }}
                          breakpoints={{
                            0: {
                              slidesPerView: 1,
                            },
                            480: {
                              slidesPerView: 2,
                            },
                            768: {
                              slidesPerView: 3,
                            },
                            1280: {
                              slidesPerView: 4,
                            },
                            1400: {
                              slidesPerView: 6,
                            },
                          }}
                        >
                          <div
                            className="fp__swiper-wrapper swiper-wrapper"
                            style={{ marginBottom: '33px' }}
                          >
                            {props.alternativeItems.map((item, index) => (
                              <ItemCarouselCard
                                key={index}
                                item={item}
                                isAuthenticated={isAuthenticated}
                                isPriceVisible={isPriceVisible}
                                validateRxAndAddToCart={props.validateRxAndAddToCart}
                                showStockStatus={true}
                              />
                            ))}
                          </div>
                        </Swiper>
                        {/* <div className="fp__navigation">
                    <div className="fp__navigation--prev swiper-button-prev">
                        <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
                    </div>
                    <div className="fp__navigation--next swiper-button-next">
                        <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                    </div>
                </div> */}
                      </div>

                      {/* </div> */}
                    </div>
                  </div>
                )}
                {featuredProducts.length > 0 && (
                  <div className="productDetails__featured">
                    <div className="container">
                      <div className="productDetails__featured-title">
                        <h2 className="bb__name-heading">Featured Products</h2>
                      </div>
                      <div className="" style={{ marginBottom: '33px' }}>
                        <Swiper
                          className="fp__swiper swiper"
                          slidesPerView={2}
                          modules={[Navigation, Pagination]}
                          pagination={{ clickable: true }}
                          autoplay={false}
                          spaceBetween={22}
                          navigation={{
                            nextEl: '.fp__navigation--next',
                            prevEl: '.fp__navigation--prev',
                          }}
                          breakpoints={{
                            0: {
                              slidesPerView: 2,
                            },
                            480: {
                              slidesPerView: 2,
                            },
                            768: {
                              slidesPerView: 3,
                            },
                            1280: {
                              slidesPerView: 4,
                            },
                            1400: {
                              slidesPerView: 6,
                            },
                          }}
                        >
                          <div
                            className="fp__swiper-wrapper swiper-wrapper"
                            style={{ marginBottom: '33px' }}
                          >
                            {featuredProducts.map((item, index) => (
                              <ItemCarouselCard
                                key={index}
                                item={item}
                                isAuthenticated={isAuthenticated}
                                isPriceVisible={isPriceVisible}
                                validateRxAndAddToCart={props.validateRxAndAddToCart}
                                showStockStatus={false}
                              />
                            ))}
                          </div>
                        </Swiper>
                        {/* <div className="fp__navigation">
                    <div className="fp__navigation--prev swiper-button-prev">
                        <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
                    </div>
                    <div className="fp__navigation--next swiper-button-next">
                        <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                    </div>
                </div> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Tab hidden below */}

              {/* <div className="products-tabs prct">
              <div className="prct__block">
                <div className="container">
                  <div className="prct__boxes">
                    {props.alternativeItems.length > 0 && (
                      <div className="prct__btn active">
                        <a href="#alternative-products" className="prct__text">
                          Alternative Products
                        </a>
                      </div>
                    )}
                    {Object.entries(productAttributes)?.length > 0 && (
                      <div className="prct__btn">
                        <a href="#product-details" className="prct__text">
                          Product Details
                        </a>
                      </div>
                    )}
                    {product.itemFile.length > 0 && (
                      <div className="prct__btn">
                        <a href="#downloads" className="prct__text">
                          Downloads
                        </a>
                      </div>
                    )}
                    {relatedProducts.length > 0 && (
                      <div className="prct__btn">
                        <a href="#related-products" className="prct__text">
                          Related Products
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div> */}

              {enhancedRelatedProducts.length > 0 && (
                <div id="related-products" className="prct__body">
                  <div className="productDetails__featured">
                    <div className="container">
                      <div className="productDetails__featured-title">
                        <h2 className="bb__name-heading">Related Products</h2>
                      </div>

                      <div className="" style={{ marginBottom: '33px' }}>
                        <Swiper
                          className="fp__swiper swiper"
                          // slidesPerView={6}
                          modules={[Navigation, Pagination]}
                          pagination={{ clickable: true }}
                          autoplay={false}
                          spaceBetween={22}
                          navigation={{
                            nextEl: '.related-next',
                            prevEl: '.related-prev',
                          }}
                          breakpoints={{
                            0: {
                              slidesPerView: 2,
                            },
                            480: {
                              slidesPerView: 2,
                            },
                            768: {
                              slidesPerView: 3,
                            },
                            1280: {
                              slidesPerView: 4,
                            },
                            1400: {
                              slidesPerView: 6,
                            },
                          }}
                        >
                          <div
                            className="fp__swiper-wrapper swiper-wrapper"
                            style={{ marginBottom: '33px' }}
                          >
                            {enhancedRelatedProducts.map((item, index) => (
                              <ItemCarouselCard
                                key={index}
                                item={item.correlatedItem || item}
                                isAuthenticated={isAuthenticated}
                                isPriceVisible={isPriceVisible}
                                validateRxAndAddToCart={props.validateRxAndAddToCart}
                                showStockStatus={false}
                              />
                            ))}
                          </div>
                        </Swiper>
                        {/* <div className="fp__navigation">
                    <div className="fp__navigation--prev swiper-button-prev related-prev">
                        <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
                    </div>
                    <div className="fp__navigation--next swiper-button-next related-next">
                        <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                    </div>
                </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* TOP CATEGORIES */}
            {/* <div className="top-cp tcp"> */}
            <div style={{ padding: '0' }}>
              {!R.isEmpty(topProducts) && <TopProducts topProducts={topProducts} />}
            </div>
            {/* </div> */}

            {/* CLOSE PAGE HOLDER */}
          </div>
        )}
        {/* <Modal isOpen={modal} toggle={toggle} zIndex={6001}>
							<ModalHeader toggle={toggle}>Add to list</ModalHeader>
							<AddToItemListDropdown quantity={productQuantity} itemId={id} unit={unit?.id || null} />
						</Modal> */}

        <DealmedDialog
          isOpen={modal}
          onDismiss={() => setModal(false)}
          className="product-details__action-dialog"
          label="Add to List Dialog"
          style={{ backgroundColor: 'transparent' }}
        >
          <div className="product-details__action-content">
            <button
              className="product-details__action-close"
              onClick={() => setModal(false)}
              aria-label="Close Add To List Dialog"
            >
              <CloseSVG className="product-details__action-icon product-details__action-icon--close" />
            </button>
            <h2 className="product-details__action-header">Add To List</h2>
            <AddToItemListDropdown
              quantity={selectedQuantity}
              itemId={product.id}
              unit={props?.uom?.value || null}
            />
          </div>
        </DealmedDialog>
      </ProductDetailsContext.Provider>
    )
  }
  return <div />
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    product: state.shopping.product,
    quantitySelected: state.shopping.quantitySelected,
    sellableCSLs: state.shopping.sellableCSLs,
    uom: state.shopping.uom,
    alternativeItems: state.shopping.alternativeItems,
    correlatedItems: state.shopping.correlatedItems,
    allocationMax: state.shopping.allocationMax,
    category: state.shopping.product.data.category?.parent,
    subcategory: state.shopping.product.data.category,
    retrievingAllocation: state.loader.retrievingAllocation,
    accountLoading: state.loader.accountLoading,
  }
}

export default withRouter(
  connect(mapStateToProps, { setCorrelatedItems, setAlternativeItems, changeQuantity, setUom })(
    ProductHOC(TransactionHOC(ProductDetailsPage)),
  ),
)
